import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { formatCurrency } from "../../common/format-currency";
import MyStorage from "../../common/MyStorage";
import {
  userLogout,
  setAppBanner,
  setAllCategories,
} from "../../redux/actions/postActions";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import { map, tail, times, uniq } from "lodash";
import { useMediaQuery } from "react-responsive";
import { KMTracking } from "../Tracking/KMTracking";
import Cookies from "universal-cookie";
import _ from "lodash";
import { isIOS, isMobileOnly } from "react-device-detect";
import cleanURL from "../../common/cleanURL";
import { Link } from "react-router-dom";

const cookies = new Cookies();

function Header(props) {
  const [authToken, setToken] = useState("false");
  const [showSearchHistory, setSearchHistory] = useState(false);
  const [showSearchHistorySmall, setSearchHistorySmall] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [logout, setlogout] = useState(false);
  const [showSideMenu, setSidemenuVisible] = useState(false);
  const [clickedCategory, setClickedCategory] = useState<any>({});
  const [showMainCategory, setShowMainCategory] = useState(true);
  const [showSubCategory, setShowSubCategory] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showCart, setCartVisible] = useState(false);
  const [givenName, setGivenName] = useState("");
  const [cartcount, setCartCount] = useState("");
  const [showTopCursor, setShowTopCursor] = useState(false);
  const [cartamount, setCartAmount] = useState("");
  const [searchHistory, setHistory] = useState<any>([]);
  const [miniBrands, setMiniBrands] = useState<any>([]);
  const [topBannerText, setTopBannerText] = useState("");
  const [topBannerNavItem, setTopBannerNavItem] = useState<any>();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  useEffect(() => {
    setTimeout(() => {
      let ad = document.querySelector(".top .ad");

      let topmenu = document.querySelector(".topmenu");
      /* @ts-ignore */
      let adHeight = ad?.offsetHeight;
      /* @ts-ignore */
      topmenu.style.paddingTop = adHeight + "px";

      // check if getapp banner is on
      const getApp = document.querySelector(".getapp");
      if (getApp) {
        /* @ts-ignore */
        document.querySelector(".top").classList.add("offset");
        if (window.innerWidth < 768) {
          /* @ts-ignore */
          topmenu.style.paddingTop = "calc(" + adHeight + "px + 10vh)";
        }
      }

      let getAppClose = document.querySelector(".getapp .close");
    }, 1500);
  }, []);
  useEffect(() => {
    console.log(
      "Use effect called",
      props,
      isTabletOrMobile,
      isTabletOrMobileDevice
    );
    const storage = new MyStorage();
    const token = storage.getloggedIn();
    getShoutouts();
    if (props.cart_count == 0) {
      const _cartcount: any = new MyStorage().getCartCount();
      const _cartamount: any = new MyStorage().getCartAmount();
      setCartCount(_cartcount);
      setCartAmount(_cartamount);
    } else {
      setCartCount(props.cart_count);
      setCartAmount(props.cart_amount);
    }
    if (token == "true") {
      const given_name = storage.getName()?.split(" ")[0];
      setGivenName(given_name ? given_name : "");
      setToken(token);
    } else {
      setToken("false");
      setlogout(false);
      props?.history?.push("/login", { from: "Header" });
    }
    getCategories();
    let history = new MyStorage().getSearchHistory();
    if (history) {
      let arr = history?.split(",");
      setHistory(uniq(arr));
    }

    seeCart();
    // getPopOvers();
  }, [showSubCategory, logout, authToken, props?.props?.history]);

  const getPopOvers = async () => {
    await new WebApiCalls().getPopOvers().then((result) => {
      // console.log("result getPOPOVers", result);
    });
  };

  const getShoutouts = async () => {
    let TopRibbons: any = [];
    await new WebApiCalls().getShoutouts().then((_response) => {
      if (_response.data) {
        if (_response.data.length > 0) {
          _response.data.map((item) => {
            if (item.type == "TopRibbon" && item.status == "Y") {
              TopRibbons.push(item);
              console.log("here is the top ribbon item--------->", item);
            }
          });
          let sorted = TopRibbons.sort((a, b) => {
            return (
              new Date(b.publish_date).getTime() -
              new Date(a.publish_date).getTime()
            );
          });
          console.log(
            "here is the top ribbon item--------->(sortted)",
            JSON.parse(sorted[0]?.navigation)
          );
          setTopBannerNavItem(sorted[0]);
          if (JSON.parse(sorted[0]?.navigation)?.website_params?.nav_to) {
            console.log("control enter here");
            setShowTopCursor(true);
          }

          setTopBannerText(sorted[0].description);
        }
      }
    });
  };

  const loggedIn = new MyStorage().getloggedIn();
  const seeCart = async () => {
    const storage = new MyStorage();
    const login = storage.getloggedIn();
    if (!login || login == "false") {
      return;
    }
    const localStorage = new MyStorage();
    // this.setState({ cartSpinner: true });
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    if (userID && accessToken) {
      await new WebApiCalls()
        .getCartDetail(userID, accessToken)
        .then(async (Response) => {
          if (Response?.body?.length == 0) {
            return;
          } else if (Response.statusCode === 200) {
            await new WebApiCalls()
              .seeCart(userID, accessToken)
              .then(async (response) => {
                let a: any = 0;
                let b: any = 0;
                a = response?.Records?.map((item) => {
                  return parseInt(a + item.Quantity);
                });
                a?.map((aitem) => {
                  b = b + aitem;
                });
                let total = 0;
                let itemID: any = [];
                await response?.Records && response?.Records.map(async (item) => {
                  total = total + item.SubTotal;
                  itemID.push(item.ID);
                  let obj = {
                    ID: item.ItemDetail.ID,
                  };
                  localStorage.setCartAmount(total);
                  props.props.UpdateCartAmount(total);
                  if (item.ItemDetail.Name == "Delivery") {
                    props.props.UpdateCartCount(b - 1);
                    localStorage.setCartCount(b - 1);
                  } else {
                    localStorage.setCartCount(b);
                    props.props.UpdateCartCount(b);
                  }
                });
              });
          }
        });
    }
  };
  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  const getCategories = async () => {
    if (props?.allCategories.length > 0) {
      let tempCategories: any = [];
      props?.allCategories?.map((item) => {
        if (item?.Description !== "hidden") {
          tempCategories = [...tempCategories, item];
        }
      });
      setCategories(tempCategories);
    } else {
      await new WebApiCalls().getAllCategoriesByHerarchy().then((response) => {
        if (response) {
          props.setAllCategories(response);
          let tempCategories: any = [];
          response?.map((item) => {
            if (item?.Description !== "hidden") {
              tempCategories = [...tempCategories, item];
            }
          });
          setCategories(tempCategories);
        }
      });
    }
  };
  const logoutUser = async () => {
    const jwt_token = new MyStorage().getauthenticationFrasers();
    await new WebApiCalls().userLogout(jwt_token).then((response) => {
      if (response) {
        console.log("Logout = ", response);
      }
    });
  };
  const logoutUserArcadier = async () => {
    let accessToken= localStorage.getItem("access_token",)
    await new WebApiCalls().userArcadierLogout(accessToken).then((response) => {
      if (response) {
        console.log("Logout =", response);
        localStorage.clear();
      }
    });
  };

  const searchProducts = (keywords) => {
    let history = [keywords, ...searchHistory];
    let noDup = uniq(history);
    if (noDup.length <= 10) {
      setHistory(noDup);
      new MyStorage().setSearchHistory(noDup);
    } else {
      noDup.pop();
      setHistory(noDup);
      new MyStorage().setSearchHistory(noDup);
    }
    if (keywords !== "") {
      props?.props?.history?.push(
        `/search/${
          keywords ? keywords.replace(/ /g, "-").replace(/%/g, "-") : ""
        }`
      );
    }
  };
  const handleKeyPress = (e) => {
    if (
      e.code.toLowerCase() == "enter" ||
      e.code.toLowerCase() == "done" ||
      e.code.toLowerCase() == "submit" ||
      e.code.toLowerCase() == "return" ||
      e.code.toLowerCase() == "end" ||
      e.code.toLowerCase() == "numpadenter" ||
      e.keyCode == 13 ||
      (e.keyCode == 0 && (isTabletOrMobile || isTabletOrMobileDevice) && !isIOS)
    ) {
      if (e.target.value.length > 0) {
        searchProducts(e.target.value);
        e.target.blur();
        setSearchHistory(false);
      }
    }
  };
  const clearSearchHistory = () => {
    setHistory([]);
    new MyStorage().setSearchHistory([]);
  };
  let get = localStorage.getItem("getapp");
  return (
    <>
      {/* header */}
      <header>
        {/* announcement */}
        {(isTabletOrMobile || isTabletOrMobileDevice) &&
          props?.app_banner &&
          !get && (
            <div className="getapp">
              <div
                className="close"
                onClick={() => {
                  let ad = document.querySelector(".top .ad");
                  /* @ts-ignore */
                  let adHeight = ad.offsetHeight;
                  localStorage.setItem("getapp", adHeight);
                  props.setAppBanner(false);
                  document.querySelector("getapp")?.remove();
                  /* @ts-ignore */
                  document.querySelector(".top").classList.remove("offset");
                  /* @ts-ignore */
                  document.querySelector(".topmenu").style.paddingTop =
                    "calc(" + adHeight + "px)";
                }}
              >
                <img src="images/icon-x.svg" alt="" />
              </div>
              <div className="app-info">
                <div className="thumb">
                  <img src="images/applogo.png" alt="" />
                </div>
                <div className="text">
                  <strong>Shop Frasers eStore on Frasers Experience App</strong>
                </div>
              </div>
              <div className="btn">
                <a
                  href="https://frxapp.page.link/frasers-experience"
                  style={{ color: "#fff" }}
                >
                  GET APP
                </a>
              </div>
            </div>
          )}
        <a
          className="top"
          style={{ cursor: showTopCursor ? "pointer" : "auto" }}
          onClick={() => {
            let nav = topBannerNavItem
              ? JSON.parse(topBannerNavItem.navigation)
              : undefined;
            let topNav =
              nav == undefined || nav == "undefined" || nav.section == ""
                ? ""
                : `${
                    nav.params.hidden
                      ? `/categories-listing/${cleanURL(
                          nav.params?.cat_name
                        )}/${nav?.params?.ID}?Medium=${
                          nav?.params?.CampaignMedium
                        }&link=${nav?.params?.link}`
                      : nav.params.comingFromStore
                      ? `/brand/${cleanURL(nav.params?.screenName)}/${
                          nav.params.ID
                        }?Medium=${nav.params.CampaignMedium}&link=${
                          nav?.params?.link
                        }`
                      : nav.params?.blog_name
                      ? `/blog/${nav.params.ID}/${cleanURL(
                          nav.params.blog_name
                        )}?Medium=${nav.params?.CampaignMedium}&link=${
                          nav.params?.link
                        }`
                      : `/category/${cleanURL(nav.params.cat_name)}/${
                          nav.params.ID
                        }?Medium=${nav.params?.CampaignMedium}&link=${
                          nav.params?.link
                        }`
                  }`;
            if (topNav) {
              props.props.history.push(topNav, { from: "Home" });
              window.location.reload();
            }
          }}
        >
          <div
            className="ad ribbon-top"
            dangerouslySetInnerHTML={{ __html: topBannerText }}
          />

          {/* <span dangerouslySetInnerHTML={{ __html: topBannerText ? topBannerText : '' }} /> */}
          {/* </div> */}
        </a>

        {/* /announcement */}

        {/* topmenu */}
        <div className="topmenu">
          {/* logo-hamburger */}
          <div className="logo-hamburger">
            {/* hamburger */}
            <div
              className="hamburger"
              onClick={() => {
                setShowSubCategory(false);
                setShowMainCategory(true);
                setSidemenuVisible(!showSideMenu);
              }}
            >
              <div className="patty"></div>
              <div className="patty"></div>
              <div className="patty"></div>
            </div>
            {/* /hamburger */}

            <div className="logo">
              <Link to="/home">
                <img src="images/logo.png" alt="Frasers eStore" />
              </Link>
            </div>

            {/* icons (mobile only) */}
            <div className="icons mobile-flex">
              {/* searchicon */}
              <div
                className="searchicon"
                onClick={() => {
                  setSearchHistorySmall(!showSearchHistorySmall);
                }}
              >
                <img className="" src="images/search.svg" alt="search" />
              </div>
              {/* /searchicon */}

              {/* cart */}
              <div className="cart">
                {/* cart-btn */}
                <div
                  className="cart-btn"
                  onClick={() => {
                    let data = {
                      visiting: "CartPreview",
                      step: "Clicked on Cart Icon from header ",
                    };
                    tracker("HeaderMenu", data);
                    setCartVisible(!showCart);
                  }}
                >
                  <span>{props.cart_count}</span>
                </div>
                {/* /cart-btn */}

                {/* cart-preview */}
                {/* working here */}
                {showCart && (
                  <div
                    className={"cart-preview active"}
                    style={{
                      backgroundColor: "rgba(0,0,0,0.5)",
                      top: 0,
                      height: 5000,
                      width: 1000,
                    }}
                    onClick={() => {
                      setCartVisible(false);
                    }}
                  >
                    <div className="cart-preview active">
                      <div className="contents">
                        <div className="in-cart">
                          <div className="qty">
                            {props.cart_count} items in bag
                          </div>
                          <div className="price">
                            {formatCurrency(props.cart_amount)}
                          </div>
                        </div>
                        <a
                          className="blackbutton"
                          onClick={async () => {
                            let cart_id = await new MyStorage().getCartID();
                            if (cart_id) {
                              let data = {
                                visiting: "ViewBagHeader",
                                CartID: cart_id,
                                "Cart Item Count": props.cart_count,
                                "Cart Price": formatCurrency(props.cart_amount),
                                CartEmpty: false,
                                step: "Clicked on View Bag in Cart preview from header ",
                              };
                              tracker("HeaderMenu", data);
                              props?.props?.history.push(`/my-bag`);
                            } else {
                              let data = {
                                visiting: "ViewBagHeader",
                                CartEmpty: true,
                                step: "Clicked on View Bag in Cart preview from header ",
                              };
                              tracker("HeaderMenu", data);
                              props?.props?.history.push(`/my-bag`);
                            }
                          }}
                        >
                          View Bag
                        </a>
                        <a className="continue-shopping">Continue Shopping</a>
                      </div>
                    </div>
                  </div>
                )}
                {/* /cart-preview */}
              </div>
              {/* /cart */}
            </div>
            {/* /icons */}
          </div>
          {/* logo-hamburger (mobile only) */}
          {/* search bar for mobile view */}
          {showSearchHistorySmall == true && (
            <div style={{ marginTop: "20px", width: "100%" }}>
              <div className="search">
                <input
                  type="search"
                  placeholder="Search for items, brands and inspiration"
                  name="search"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                  onKeyPress={(e) => {
                    setTimeout(() => {
                      handleKeyPress(e);
                    }, 2000);
                  }}
                  autoComplete={"off"}
                />
              </div>
              {searchHistory.length > 0 && (
                <div className="search-tags active">
                  <div className="title-clear">
                    <div className="title">Search History</div>
                    <a
                      id="search-clear"
                      onClick={() => {
                        clearSearchHistory();
                      }}
                    >
                      clear
                    </a>
                  </div>
                  {searchHistory &&
                    searchHistory.map((data, i) => {
                      return (
                        <div
                          className="tag"
                          key={i}
                          onClick={() => {
                            if (data) {
                              setSearchKeyword(data);
                              searchProducts(data);
                              setSearchHistorySmall(!showSearchHistorySmall);
                            }
                          }}
                        >
                          {data}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          )}
          {/* search bar */}

          <div className="search-wrap">
            <div className="search">
              <input
                type="search"
                placeholder="Search for items, brands and inspiration"
                name="search"
                onChange={(e) => {
                  setSearchKeyword(e.target.value);
                }}
                onClick={() => {
                  setSearchHistory(!showSearchHistory);
                }}
                value={searchKeyword}
                autoComplete={"off"}
                onKeyPress={(e) => {
                  handleKeyPress(e);
                }}
              />

              <a
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // setSearchHistory(!showSearchHistory)
                  if (searchKeyword !== "") {
                    searchProducts(searchKeyword);
                    setSearchHistory(false);
                  }
                }}
              >
                <img className="" src="images/search.svg" alt="search" />
              </a>
            </div>
            {showSearchHistory && searchHistory.length > 0 && (
              <div className="search-tags active">
                <div className="title-clear">
                  <div className="title">Search History</div>
                  <a
                    id="search-clear"
                    onClick={() => {
                      clearSearchHistory();
                    }}
                  >
                    clear
                  </a>
                </div>
                {searchHistory &&
                  searchHistory.map((data, i) => {
                    return (
                      <div
                        className="tag"
                        key={i}
                        onClick={() => {
                          if (data) {
                            setSearchKeyword(data);
                            searchProducts(data);
                            setSearchHistory(!showSearchHistory);
                          }
                        }}
                      >
                        {data}
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
          {/* /search bar */}

          {/* icons */}
          <div className="icons desktop-flex">
            {/* cart */}
            <div className="cart">
              <div
                className="cart-btn"
                onClick={() => {
                  setCartVisible(false);
                  if (props?.props?.changeIsProduct) {
                    props?.props?.changeIsProduct();
                  }
                }}
              >
                <span>{props.cart_count}</span>
              </div>
              <div
                className={`cart-preview ${showCart ? "active" : ""} ${
                  props?.props?.isProductAdded ? "added" : ""
                }`}
                onClick={() => {
                  setCartVisible(false);
                  if (props?.props?.changeIsProduct) {
                    props?.props?.changeIsProduct();
                  }
                }}
              >
                {props?.props?.isProductAdded && (
                  <div className="added-close">
                    <div className="added">
                      {props?.props?.productQty} items added to bag
                    </div>
                    <div
                      className="close"
                      onClick={() => {
                        setCartVisible(false);
                        props?.props?.changeIsProduct();
                      }}
                    >
                      <img src="images/close-black.png" alt="" />
                    </div>
                  </div>
                )}
                <div className="contents">
                  <div className="in-cart">
                    <div className="qty">{props.cart_count} items in bag</div>
                    <div className="price">
                      {formatCurrency(props.cart_amount)}
                    </div>
                  </div>
                  <a
                    className="blackbutton"
                    onClick={async () => {
                      let cart_id = await new MyStorage().getCartID();
                      props?.props?.history.push(`/my-bag`);
                    }}
                  >
                    View Bag
                  </a>
                  {props?.props?.isProductAdded && (
                    <a
                      style={{ cursor: "pointer", textDecoration: "underline" }}
                      onClick={() => {
                        // props?.props?.history.push("/");
                      }}
                      className="continue-shopping"
                    >
                      Continue Shopping
                    </a>
                  )}
                </div>
              </div>
            </div>
            {/* /cart */}

            {/* {/* account */}
            <div className="account">
              {/* {/* icon */}
              <a className="login">
                <img src="images/login.svg" alt="login" />
              </a>
              {/* {/* icon */}

              {/* {/* account-preview */}
              <div className="account-preview">
                {loggedIn == "true" ? (
                  <div className="greeting">
                    <div className="log-inout">
                      Hello, {givenName}
                      <a
                        onClick={async() => {
                          setShowSubCategory(false);
                          setShowMainCategory(false);
                          setSidemenuVisible(false);
                          setlogout(true);
                          await logoutUser();
                          await logoutUserArcadier()
                          cookies.remove("page_reload_count");
                          cookies.remove("token");
                          props.userLogout();
                          props?.props?.history?.push("/");

                        }}
                        className="notyou"
                      >
                        Sign Out
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="greeting">
                    <div className="log-inout">
                      <a
                        onClick={() => {
                          setSidemenuVisible(false);
                          props?.props?.history.push("/login", {
                            from: "Header",
                          });
                        }}
                      >
                        Sign In
                      </a>
                      <a
                        onClick={() => {
                          setSidemenuVisible(false);
                          props?.props?.history.push("/sign-up", {
                            from: "Header",
                          });
                        }}
                      >
                        Join
                      </a>
                    </div>
                  </div>
                )}

                {/* {/* links */}
                <div className="links">
                  <ul>
                    <li>
                      <a
                        onClick={() => {
                          let data = {
                            visiting: "MyOrders",
                            step: "Clicked on My Orders from header ",
                          };
                          tracker("HeaderMenu", data);
                          setSidemenuVisible(false);
                          props?.props?.history?.push("/my-orders");
                        }}
                      >
                        My Orders
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          let data = {
                            visiting: "AddressBook",
                            step: "Clicked on Address Book from header ",
                          };
                          tracker("HeaderMenu", data);
                          setSidemenuVisible(false);
                          props?.props?.history?.push("/address-book", {
                            from: "Header",
                          });
                        }}
                      >
                        Address Book
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          let data = {
                            visiting: "PaymentMethods",
                            step: "Clicked on Pament Methods from header",
                          };
                          tracker("HeaderMenu", data);
                          setSidemenuVisible(false);
                          props?.props?.history?.push("/payment-methods", {
                            from: "Header",
                          });
                        }}
                      >
                        Payment Methods
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.frasersexperience.com/fr-page.php?CategoryID=744"
                        onClick={() => {
                          let eventData = {
                            "location type": "Header",
                          };
                          tracker(
                            "Opened Order Help and FAQ Screen",
                            eventData
                          );
                          setSidemenuVisible(false);
                        }}
                      >
                        Order Help & FAQ
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          let data = {
                            visiting: "Profile",
                            step: "Clicked on Profile from header",
                          };
                          tracker("HeaderMenu", data);
                          setSidemenuVisible(false);
                          props?.props?.history?.push("/profile");
                        }}
                      >
                        Profile
                      </a>
                    </li>
                  </ul>
                </div>
                {/* {/* /links */}
              </div>
              {/* {/* /account-preview */}
            </div>
            {/* {/* /account */}

            {/* app download icon */}
            <a
              href="https://frxapp.page.link/frasers-experience"
              className="appdownload"
              onClick={() => {
                let data = {
                  visiting: "DownloadFRxApp",
                  step: "Clicked on Download the Frasers Experience App from header",
                };
                tracker("HeaderMenu", data);
              }}
            >
              <img src="images/applogo.svg" alt="download app" />
              <div className="text">
                Download the
                <br />
                Frasers Experience
                <br />
                App
              </div>
            </a>
            {/* /app download icon */}
          </div>
          {/* /icons */}
        </div>
        {/* /topmenu */}

        {/* sidemenu */}

        <div className={`sidemenu ${showSideMenu ? "active" : ""}`}>
          {/* content wrap */}

          <div className="content-wrap">
            {authToken == "true" ? (
              <div className="close-login-app">
                {!showSubCategory ? (
                  <div className="close">
                    <img
                      src="images/icon-x.svg"
                      alt=""
                      onClick={() => {
                        setSidemenuVisible(false);
                      }}
                    />
                  </div>
                ) : (
                  <div className="close">
                    <img
                      src="images/prev.png"
                      alt=""
                      onClick={() => {
                        setShowSubCategory(false);
                        setShowMainCategory(true);
                      }}
                    />
                  </div>
                )}
                <div className="greeting">Hello, {givenName}</div>
                <a
                  onClick={() => {
                    let data = {
                      visiting: "Signout",
                      step: "Clicked on Sign Out from header",
                    };
                    tracker("HeaderMenu", data);                   
                    setShowSubCategory(false);
                    setShowMainCategory(false);
                    setSidemenuVisible(false);
                    setlogout(true);
                    props.userLogout();
                    localStorage.clear();
                    cookies.remove("page_reload_count");
                    cookies.remove("token");
                    new MyStorage().clearStorage();
                    props?.props?.history?.push("/");
                  }}
                  className="signout"
                >
                  Sign Out
                </a>
              </div>
            ) : (
              <div className="close-login-app">
                {!showSubCategory ? (
                  <div className="close">
                    <img
                      src="images/icon-x.svg"
                      alt=""
                      onClick={() => {
                        setSidemenuVisible(false);
                      }}
                    />
                  </div>
                ) : (
                  <div className="close">
                    <img
                      src="images/prev.png"
                      alt=""
                      onClick={() => {
                        setShowSubCategory(false);
                        setShowMainCategory(true);
                      }}
                    />
                  </div>
                )}
                <div className="log-inout">
                  <a
                    onClick={() => {
                      props?.props?.history?.push("/login", { from: "Header" });
                    }}
                  >
                    Sign In
                  </a>
                  <a
                    onClick={() => {
                      props?.props?.history?.push("/sign-up", {
                        from: "Header",
                      });
                    }}
                  >
                    Join
                  </a>
                </div>
              </div>
            )}
            {/* close, login and app */}

            {/* scrollable */}
            <div className="scrollable">
              {/* general nav */}
              {showMainCategory && (
                <>
                  <nav>
                    <a
                      onClick={() => {
                        let data = {
                          visiting: "MyOrders",
                          step: "Clicked on My Orders from header",
                        };
                        tracker("HeaderMenu", data);
                        props?.props?.history?.push("/my-orders");
                        setSidemenuVisible(false);
                      }}
                    >
                      My Orders
                    </a>
                    <ul>
                      <a
                        onClick={() => {
                          props?.props?.history?.push("/my-orders");
                          setSidemenuVisible(false);
                        }}
                      >
                        Orders
                      </a>
                      <a
                        onClick={() => {
                          setSidemenuVisible(false);
                          props?.props?.history?.push(
                            `/my-orders/${"refunds"}`
                          );
                        }}
                      >
                        Returns
                      </a>
                    </ul>
                    <a
                      onClick={() => {
                        let data = {
                          visiting: "AddressBook",
                          step: "Clicked on Address Book from header ",
                        };
                        tracker("HeaderMenu", data);
                        props?.props?.history?.push("/address-book", {
                          from: "Header",
                        });
                        setSidemenuVisible(false);
                      }}
                    >
                      Address Book
                    </a>
                    <a
                      onClick={() => {
                        let data = {
                          visiting: "PaymentMethods",
                          step: "Clicked on Pament Methods from header ",
                        };
                        tracker("HeaderMenu", data);
                        props?.props?.history?.push("/payment-methods", {
                          from: "Header",
                        });
                        setSidemenuVisible(false);
                      }}
                    >
                      Payment Methods
                    </a>
                    <a
                      target="_blank"
                      href="https://www.frasersexperience.com/fr-page.php?CategoryID=744"
                      onClick={() => {
                        let eventData = {
                          "location type": "Header",
                        };
                        tracker("Opened Order Help and FAQ Screen", eventData);
                        setSidemenuVisible(false);
                      }}
                    >
                      Order Help & FAQ
                    </a>
                    <a
                      onClick={() => {
                        let data = {
                          visiting: "Profile",
                          step: "Clicked on Profile from header ",
                        };
                        tracker("HeaderMenu", data);
                        props?.props?.history?.push("/profile");
                        setSidemenuVisible(false);
                      }}
                    >
                      Profile
                    </a>

                    <a
                      href="https://frxapp.page.link/frasers-experience"
                      className="appdownload"
                      onClick={() => {
                        let data = {
                          visiting: "DownloadFRxApp",
                          step: "Clicked on Download the Frasers Experience App from header ",
                        };
                        tracker("HeaderMenu", data);
                        setSidemenuVisible(false);
                      }}
                    >
                      <img src="images/applogo.svg" alt="download app" />
                      <div className="text">
                        Download the
                        <br />
                        Frasers Experience App
                      </div>
                    </a>
                  </nav>

                  <div className="categories lvltwo">
                    {categories?.map((item: any, index) => {
                      return (
                        <a
                          key={index}
                          onClick={() => {
                            // props?.props?.history?.push(`/category/${item.Name}`)
                            setShowMainCategory(false);
                            // console.log("Clicked Category:  ", item);
                            setClickedCategory(item);
                            setShowSubCategory(true);
                          }}
                          className="fashion"
                        >
                          <div className="darken"></div>
                          <img src={item?.Media[0]?.MediaUrl} alt="" />
                          <span>{item?.Name}</span>
                        </a>
                      );
                    })}
                  </div>
                </>
              )}
              {/* /cateogories */}

              {/* sub-categories */}

              {showSubCategory && (
                <>
                  {clickedCategory && (
                    <div className="categories lvltwo">
                      <a
                        onClick={() => {
                          props?.props?.history?.push(
                            `/category/${cleanURL(clickedCategory.Name)}/${
                              clickedCategory.ID
                            }`
                          );
                        }}
                        className="fashion"
                      >
                        <div className="darken"></div>
                        <img src={clickedCategory?.Media[0]?.MediaUrl} alt="" />
                        <span>{clickedCategory?.Name}</span>
                      </a>
                    </div>
                  )}
                  <div className="sub-categories show">
                    {clickedCategory?.ChildCategories?.map(
                      (item: any, index: number) => {
                        return (
                          <a
                            key={index}
                            onClick={() => {
                              setSidemenuVisible(false);
                              props?.props?.history?.push(
                                `/category/${cleanURL(item?.Name)}/${item?.ID}`
                              );
                            }}
                          >
                            {item?.Name}
                          </a>
                        );
                      }
                    )}
                    {/*View All for mobile device start here*/}
                    <a
                      onClick={() => {
                        props?.props?.history?.push(
                          `/category/${cleanURL(clickedCategory.Name)}/${
                            clickedCategory.ID
                          }`
                        );
                      }}
                      className="fashion"
                    >
                      <strong>View All &raquo; </strong>
                    </a>
                    {/*View All for mobile device ends here */}
                    {/* sidemenu featured brands */}
                    {clickedCategory?.bannerType == "brands" &&
                    clickedCategory?.miniBrands?.length > 0 ? (
                      <div className="featured-brands">
                        {clickedCategory?.miniBrands.map((item, index) => {
                          return (
                            <Link
                              key={index}
                              to={{
                                pathname: `/brand/${cleanURL(
                                  item?.DisplayName
                                )}/${item?.ID}`,
                              }}
                              className="item"
                            >
                              <img src={item?.image} />
                              <div className="text">{item?.DisplayName}</div>
                            </Link>

                            // <a
                            //   // href={item?.deeplink}
                            //   className="item"
                            //   style={{
                            //     justifyContent: "center",
                            //     alignItems: "center",
                            //     minWidth: "100%",
                            //   }}
                            //   onClick={() => {
                            //     let sectionObj = JSON.parse(item?.deeplink);
                            //     const pathname = new URL(
                            //       JSON.parse(
                            //         item.deeplink
                            //       ).website_params.nav_to
                            //     ).pathname;
                            //     if (sectionObj?.params?.hidden == true) {
                            //       props?.props?.history?.push(
                            //         `/categories-listing/${cleanURL(
                            //           sectionObj?.params?.cat_name
                            //         )}/${sectionObj?.params?.ID}?Medium=${
                            //           sectionObj?.params?.CampaignMedium
                            //         }&link=${sectionObj?.params?.link}`,
                            //         { from: "Side Menu" }
                            //       );
                            //     } else {
                            //       props?.props?.history?.push(pathname, {
                            //         from: "Side Menu",
                            //       });
                            //     }
                            //     setSidemenuVisible(!showSideMenu);
                            //   }}
                            //   key={index}
                            // >
                            //   <img src={item?.image_url} />
                            //   <div
                            //     className="text"
                            //     style={{ display: "none" }}
                            //   >
                            //     {item?.description}
                            //   </div>
                            // </a>
                          );
                        })}
                      </div>
                    ) : clickedCategory.bannerType == "banner_featured" &&
                      clickedCategory.miniBanners.length > 0 ? (
                      clickedCategory?.miniBanners?.map(
                        (item, index) => {
                          if (index > 0) {
                            return;
                          } else {
                            return (
                              <Link
                                to={{
                                  pathname:
                                    item?.deeplink == "undefined" ||
                                    item?.deeplink == undefined ||
                                    JSON.parse(item?.deeplink)?.section == ""
                                      ? "javascript:void(0)"
                                      : JSON.parse(item?.deeplink)?.params
                                          ?.hidden
                                      ? `/categories-listing/${cleanURL(
                                          JSON.parse(item?.deeplink)?.params
                                            ?.cat_name
                                        )}/${
                                          JSON.parse(item?.deeplink)?.params?.ID
                                        }?Medium=${
                                          JSON.parse(item?.deeplink)?.params
                                            ?.CampaignMedium
                                        }&link=${
                                          JSON.parse(item?.deeplink)?.params
                                            ?.link
                                        }`
                                      : new URL(
                                          JSON.parse(
                                            item?.deeplink
                                          )?.website_params.nav_to
                                        ).pathname,

                                  search:
                                    item?.deeplink == "undefined" ||
                                    item?.deeplink == undefined ||
                                    JSON.parse(item?.deeplink)?.section == ""
                                      ? ""
                                      : JSON.parse(item?.deeplink)?.params
                                          ?.hidden
                                      ? `?Medium=${
                                          JSON.parse(item?.deeplink)?.params
                                            ?.CampaignMedium
                                        }&link=${
                                          JSON.parse(item?.deeplink)?.params
                                            ?.link
                                        }`
                                      : new URL(
                                          JSON.parse(
                                            item?.deeplink
                                          )?.website_params.nav_to
                                        ).pathname,
                                  state: { from: "Menu" },
                                }}
                                className="item"
                                key={index}
                              >
                                <img src={item?.image_url} alt="asdfas" />
                                {/* <div className="text">{item?.description}</div> */}
                              </Link>
                            );
                          }
                        }
                        // ""
                      )
                    ) : (
                      ""
                    )}

                    {/* /sidemenu featured brands */}
                  </div>
                </>
              )}
              {/* /sub-categories */}
            </div>
            {/* scrollable */}
          </div>
          {/* /content wrap */}
        </div>
        {/* /sidemenu */}
      </header>
      <div
        className={`main-overlay ${showSideMenu ? "active" : ""}`}
        onClick={() => {
          setSidemenuVisible(!showSideMenu);
        }}
      ></div>
    </>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, cart_amount, app_banner, allCategories } =
    state.UserReducer;
  return { cart_count, cart_amount, app_banner, allCategories };
};
const actions = {
  userLogout,
  setAppBanner,
  setAllCategories,
};
export default connect(mapStateToProps, actions)(Header);
